// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_BRAND = "Zna\u010dka";
export const STROLLER_HIDE_FEATURES = "Skry parametre";
export const STROLLER_MORE_FEATURES = "V\u0161etky parametre";
